/* Tysk katalog for locale-no.js (del 4 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'adv.sales.move.chaseSlowPayers.effectLbl': 'Mögliche Verkürzung der Kreditdauer',
  'adv.sales.move.chaseSlowPayers.effectNote': 'auf deinen eigenen Durchschnitt — die Wirkung in Kronen hängt davon ab, wann der Kunde tatsächlich zahlt',
  'adv.sales.move.chaseSlowPayers.action': 'Rechnungsliste ansehen',
  'adv.sales.move.reviewDiscounts.title': 'Rabatte überprüfen',
  'adv.sales.move.reviewDiscounts.text': 'Du hast in diesem Jahr {amount} Rabatt gewährt, im Schnitt {pct} % pro Rechnung.',
  'adv.sales.move.reviewDiscounts.effectLbl': 'Geschätzte Wirkung',
  'adv.sales.move.reviewDiscounts.effectNote': 'bei Halbierung des Rabattniveaus',
  'adv.sales.move.reviewDiscounts.action': 'Rechnungsliste ansehen',
  'adv.sales.move.spreadCustomers.title': 'Kundenbasis verbreitern',
  'adv.sales.move.spreadCustomers.text': '{name} steht für {pct} % des Umsatzes. Ein einzelner Kunde sollte den Umsatz nicht allein tragen.',
  'adv.sales.move.spreadCustomers.effectLbl': 'Anteil des größten Kunden',
  'adv.sales.move.spreadCustomers.effectNote': 'das ist das Risiko, kein Gewinn',
  'adv.sales.move.spreadCustomers.action': 'Kunden ansehen',
  'adv.sales.move.testPriceIncrease.title': 'Preiserhöhung erwägen',
  'adv.sales.move.testPriceIncrease.text': 'Teste, was ein um {pct} % höherer Preis mit dem Umsatz macht, bevor du dich entscheidest.',
  'adv.sales.move.testPriceIncrease.effectLbl': 'Geschätzte jährliche Wirkung',
  'adv.sales.move.testPriceIncrease.effectNote': 'bei aktuellem Volumen',
  'adv.sales.move.testPriceIncrease.action': 'Produkte ansehen',
  'adv.sales.move.growRecurring.title': 'Mehr wiederkehrenden Umsatz aufbauen',
  'adv.sales.move.growRecurring.text': '{pct} % des Umsatzes sind wiederkehrend. Kommst du in Richtung {target} %, wird der Umsatz deutlich planbarer.',
  'adv.sales.move.growRecurring.effectLbl': 'Umsatz, der planbar werden kann',
  'adv.sales.move.growRecurring.effectNote': 'wenn der Anteil das Ziel erreicht',
  'adv.sales.move.growRecurring.action': 'Abonnements ansehen',
  'adv.sales.scn.title': 'Umsatzszenarien — Was passiert, wenn …',
  'adv.sales.scn.sub': 'Wirkung auf Umsatz, Ergebnis und Liquidität',
  'adv.sales.scn.help': 'Wähle ein Szenario, um Vorher/Nachher für Umsatz, Ergebnis, Marge und Liquidität zu sehen, zusammen mit den Annahmen, die ich zugrunde gelegt habe. Die Zahlen sind Berechnungen, keine Garantien.',
  'adv.sales.scn.metric': 'Kennzahl',
  'adv.sales.scn.base': 'Basis',
  'adv.sales.scn.after': 'Nach Szenario',
  'adv.sales.scn.change': 'Veränderung',
  'adv.sales.scn.row.revenue': 'Umsatz',
  'adv.sales.scn.row.result': 'Ergebnis',
  'adv.sales.scn.row.margin': 'Ergebnismarge',
  'adv.sales.scn.row.liquidity': 'Berechneter Plansaldo',
  'adv.sales.scn.points': '{points} PP',
  'adv.sales.scn.assumptions': 'Annahmen',
  'adv.sales.scn.showAssumptions': 'Annahmen anzeigen',
  'adv.sales.scn.confidence': 'Sicherheit',
  'adv.sales.scn.risk': 'Risiko',
  'adv.sales.scn.scope': 'Umfang',
  'adv.sales.scn.q.priceUp': 'Ich erhöhe die Preise',
  'adv.sales.scn.q.volumeDown': 'Das Absatzvolumen sinkt',
  'adv.sales.scn.q.halveDiscounts': 'Ich streiche die Hälfte der Rabatte',
  'adv.sales.scn.q.loseTopCustomer': 'Ich verliere {name}',
  'adv.sales.scn.q.growRecurring': 'Wiederkehrender Umsatz steigt um {pct} %',
  'adv.sales.scn.summary.priceUp': 'Bei aktuellem Volumen bringt eine Preiserhöhung um {pct} % rund {delta} mehr Jahresumsatz. Eine Preiserhöhung verursacht keine zusätzlichen Waren- oder Stundenkosten, daher schlägt der gesamte Betrag auf das Ergebnis durch.',
  'adv.sales.scn.summary.volumeDown': 'Ein Volumenrückgang um {pct} % nimmt rund {delta} aus dem Umsatz. Die Berechnung setzt voraus, dass die Kosten gleich bleiben, das ist also das härteste Ergebnis — sinken die Wareneinkäufe mit dem Volumen, fällt der Einbruch kleiner aus.',
  'adv.sales.scn.summary.halveDiscounts': 'Du hast in diesem Jahr {amount} Rabatt gewährt, im Schnitt {pct} %. Halbierst du das Niveau, holst du rund {delta} herein — vorausgesetzt, die Kunden bleiben.',
  'adv.sales.scn.summary.loseTopCustomer': 'Fällt {name} weg, verlierst du {delta} — {pct} % des Umsatzes. Diese Zahl macht es lohnenswert, die Kundenbasis zu verbreitern, bevor es passiert.',
  'adv.sales.scn.summary.growRecurring': 'Steigt der wiederkehrende Umsatz um {pct} %, bringt das rund {delta} mehr pro Jahr. Wiederkehrende Einnahmen sind der planbarste Umsatz, den du hast.',
  'adv.sales.scn.assumption.priceUp': 'Das Volumen bleibt gleich. Gilt für alle Produkte und Dienstleistungen.',
  'adv.sales.scn.assumption.volumeDown': 'Die Kosten bleiben gleich. Plumme hat keinen Einstandspreis pro Produkt, daher kann ich nicht berechnen, wie viel der Kosten mit dem Volumen sinkt.',
  'adv.sales.scn.assumption.halveDiscounts': 'Die Kunden kaufen bei niedrigerem Rabatt gleich viel. Berechnet aus den in diesem Jahr tatsächlich gewährten Rabatten.',
  'adv.sales.scn.assumption.loseTopCustomer': 'Kein Teil des Umsatzes wird durch andere Kunden ersetzt. Berechnet aus den tatsächlich gebuchten Verkäufen des Kunden.',
  'adv.sales.scn.assumption.growRecurring': 'Das Wachstum kommt zum heutigen Umsatz hinzu, nicht an seine Stelle.',
  'adv.sales.scn.riskText.priceUp': 'Sinkt das Volumen stärker als die Preiserhöhung, verpufft der Effekt. Beobachte das Verkaufsvolumen in den ersten zwei Monaten.',
  'adv.sales.scn.riskText.volumeDown': 'Sinkt das Volumen zuerst bei den profitabelsten Kunden, fällt der Einbruch größer aus.',
  'adv.sales.scn.riskText.halveDiscounts': 'Kunden, die wegen des Rabatts kaufen, könnten abspringen. Teste es zuerst bei wenigen.',
  'adv.sales.scn.riskText.loseTopCustomer': 'Fixkosten verschwinden nicht mit dem Kunden, daher trifft es das Ergebnis härter als den Umsatz.',
  'adv.sales.scn.riskText.growRecurring': 'Wiederkehrende Verträge binden dich über längere Zeit an Preis und Lieferung.',
  'adv.sales.scn.scopeText.all': 'Alle Produkte und Dienstleistungen',
  'adv.sales.scn.scopeText.discounted': 'Nur Rechnungen mit Rabatt',
  'adv.sales.scn.scopeText.topCustomer': 'Nur größter Kunde',
  'adv.sales.scn.scopeText.recurring': 'Nur wiederkehrende Verkäufe',
  'adv.sales.closerTag': 'Das würde ich tun',
  'adv.tab.tax': 'Steuern',
  'adv.tab.budget': 'Budget',
  'adv.tab.insight': 'Einblicke',
  'adv.plan.title': 'Budget vs. Ist',
  'adv.plan.sub': '{year} — bisher gebucht gegenüber dem Budget der ersten {months} Monate',
  'adv.plan.help': 'Die gebuchten Zahlen gelten für das bisherige Jahr, das Budget für das ganze Jahr. Ich vergleiche daher mit dem Budget bis einschließlich des laufenden Monats — sonst sähe im Januar alles weit unter Budget aus.',
  'adv.plan.tableTitle': 'Abweichung nach Kategorie',
  'adv.plan.tableSub': 'Budget der ersten {months} Monate gegenüber gebucht',
  'adv.plan.tableHelp': 'Die Zeilen sind nach der Höhe der Abweichung sortiert. Konten mit Buchungen, aber ohne Budget, werden ebenfalls angezeigt — sie sind oft die interessantesten.',
  'adv.plan.col.category': 'Kategorie',
  'adv.plan.col.budget': 'Budget bisher',
  'adv.plan.col.actual': 'Gebucht',
  'adv.plan.col.variance': 'Abweichung',
  'adv.plan.unbudgeted': 'Nicht budgetiert',
  'adv.plan.incomeVariance': 'Ertragsabweichung',
  'adv.plan.costVariance': 'Kostenabweichung',
  'adv.plan.abovePlan': 'über Plan',
  'adv.plan.belowPlan': 'unter Plan',
  'adv.plan.overPlan': 'über Plan',
  'adv.plan.underPlan': 'unter Plan',
  'adv.plan.separateNote': 'Ertrags- und Kostenabweichung werden getrennt angezeigt. Zusammengefasst könnten sich ein Minderertrag und eine Kosteneinsparung aufheben und so aussehen, als liefe alles nach Plan.',
  'adv.plan.noteWorse': '{name} weicht nach {months} Monaten um {amount} in die falsche Richtung ab. Ein Blick lohnt sich, bevor die Abweichung im restlichen Jahr wächst.',
  'adv.plan.noteBetter': '{name} liegt nach {months} Monaten {amount} besser als budgetiert.',
  'adv.plan.noteUnbudgeted': 'Auf {name} wurden {amount} gebucht, ohne dass das Konto budgetiert ist.',
  'adv.plan.editBudget': 'Budget bearbeiten',
  'adv.plan.noBudgetTitle': 'Kein Budget für dieses Jahr',
  'adv.plan.noBudgetText': 'Ohne Budget habe ich nichts, woran ich die gebuchten Zahlen messen kann. Wenn du eines anlegst, zeige ich Abweichungen nach Kategorie und melde mich, wenn etwas vom Plan abweicht.',
  'adv.plan.goToBudget': 'Budget erstellen',
  'adv.plan.notStartedTitle': 'Das Jahr hat noch nicht begonnen',
  'adv.plan.notStartedText': 'In {year} gibt es noch keine gebuchten Monate, mit denen das Budget verglichen werden kann.',
  'adv.plan.goalsTitle': 'Ziele',
  'adv.plan.goalsSub': 'Deine eigenen Ziele, gemessen an gebuchten Zahlen',
  'adv.plan.goalsHelp': 'Ein Ziel wird ab dem Jahr angezeigt, für das du es anlegst, bis du es als erledigt markierst. Ein Ziel mit überschrittener Frist bleibt stehen, bis du es neu bewertest. Ertrag, Ergebnis und Marge werden je Geschäftsjahr gemessen, der Puffer folgt dem Saldo.',
  'adv.plan.goalsEmptyTitle': 'Noch keine Ziele festgelegt',
  'adv.plan.goalsEmptyText': 'Setze ein Ziel mit Frist — zum Beispiel einen Liquiditätspuffer oder eine Ergebnismarge — dann verfolge ich den Fortschritt und melde mich, wenn du zurückfällst.',
  'adv.plan.goalNew': 'Neues Ziel',
  'adv.plan.goalEdit': 'Ziel bearbeiten',
  'adv.plan.goalSave': 'Ziel speichern',
  'adv.plan.goalSaved': 'Das Ziel wurde gespeichert',
  'adv.plan.goalSaveFailed': 'Das Ziel konnte nicht gespeichert werden',
  'adv.plan.goalDeleted': 'Das Ziel wurde gelöscht',
  'adv.plan.goalTitleLabel': 'Was ist das Ziel?',
  'adv.plan.goalTitlePh': 'z. B. Liquiditätspuffer bis Jahresende aufbauen',
  'adv.plan.goalMetricLabel': 'Was soll gemessen werden?',
  'adv.plan.goalMetricHint': 'Der aktuelle Wert stammt aus der Buchhaltung, nicht aus deiner Eingabe.',
  'adv.plan.goalTargetAmount': 'Zielwert (kr)',
  'adv.plan.goalTargetPct': 'Zielwert (%)',
  'adv.plan.goalNow': 'Aktuell',
  'adv.plan.goalTarget': 'Ziel',
  'adv.plan.goalDeadline': 'Frist',
  'adv.plan.goalDaysLeft': 'Verbleibende Tage',
  'adv.plan.goalMeasured': 'Gemessen an: {metric}',
  'adv.plan.goalFromYear': 'Ab {year}',
  'adv.plan.goalReached': 'Erreicht',
  'adv.plan.goalCompleted': 'Erledigt',
  'adv.plan.goalNeedsReview': 'Frist überschritten – Ziel prüfen',
  'adv.plan.goalComplete': 'Ziel als erledigt markieren',
  'adv.plan.goalReopen': 'Ziel wieder öffnen',
  'adv.plan.goalOverdue': 'Die Frist ist überschritten',
  'adv.plan.goalOnTrack': 'Im Plan',
  'adv.plan.goalBehind': 'Hinter dem Plan',
  'adv.plan.goalTracking': 'Wird verfolgt',
  'adv.plan.metric.buffer': 'Kassenbestand am Jahresende',
  'adv.plan.metric.income': 'Gebuchter Umsatz',
  'adv.plan.metric.result': 'Gebuchtes Ergebnis',
  'adv.plan.metric.margin': 'Ergebnismarge',
  'adv.plan.saving': 'Wird gespeichert …',
  'adv.plan.eventsTitle': 'Geplante Ereignisse',
  'adv.plan.eventsSub': 'Bekannte Ein- und Auszahlungen, die noch nicht gebucht sind',
  'adv.plan.eventsHelp': 'Ereignisse werden in dem Jahr angezeigt, zu dem ihr Datum gehört. Sie werden nicht automatisch ins nächste Jahr verschoben; ändere das Datum, wenn die Zahlung verschoben wird. Nur künftige, nicht gebuchte Ereignisse fließen in die Cashflow-Prognose ein.',
  'adv.plan.eventsEmptyTitle': 'Keine geplanten Ereignisse',
  'adv.plan.eventsEmptyText': 'Ohne erfasste Ereignisse bleibt die Cashflow-Kurve nach dem laufenden Monat flach, weil sie nur gebuchte Zahlen kennt.',
  'adv.plan.eventsNote': 'Ereignisse in früheren Monaten werden in der Kurve nicht berücksichtigt. Entferne ein Ereignis, sobald die Zahlung gebucht ist, damit es nicht doppelt zählt.',
  'adv.plan.eventNew': 'Neues Ereignis',
  'adv.plan.eventEdit': 'Ereignis bearbeiten',
  'adv.plan.eventSave': 'Ereignis speichern',
  'adv.plan.eventSaved': 'Das Ereignis wurde gespeichert',
  'adv.plan.eventSaveFailed': 'Das Ereignis konnte nicht gespeichert werden',
  'adv.plan.eventDeleted': 'Das Ereignis wurde gelöscht',
  'adv.plan.eventLabel': 'Worum geht es?',
  'adv.plan.eventLabelPh': 'z. B. Urlaubsgeld für Mitarbeitende',
  'adv.plan.eventKind': 'Typ',
  'adv.plan.eventDate': 'Datum',
  'adv.plan.eventDirection': 'Richtung',
  'adv.plan.eventDirectionHint': 'Aus senkt den Kassenbestand, ein erhöht ihn.',
  'adv.plan.directionOut': 'Vom Konto',
  'adv.plan.directionIn': 'Aufs Konto',
  'adv.plan.eventAmount': 'Betrag',
  'adv.plan.kind.salary': 'Lohn und Bonus',
  'adv.plan.kind.tax': 'Steuern und Abgaben',
  'adv.plan.kind.supplier': 'Lieferantenzahlung',
  'adv.plan.kind.investment': 'Investition',
  'adv.plan.kind.loan': 'Darlehen und Tilgung',
  'adv.plan.kind.other': 'Sonstiges',
  'adv.tab.reports': 'Berichte',
  'adv.tab.benchmark': 'Vergleich',
  'adv.basisCmp.title': 'Vergleichsgrundlage',
  'adv.basisCmp.sub': 'Woran die Zahlen tatsächlich gemessen werden',
  'adv.basisCmp.help': 'Die folgenden Kennzahlen werden nicht mit anderen Unternehmen verglichen. Zwei werden an den eigenen Zahlen des Unternehmens aus dem Vorjahr gemessen, zwei an einem festen Schwellenwert. Jede Zeile ist entsprechend gekennzeichnet.',
  'adv.basisCmp.year': 'Geschäftsjahr',
  'adv.basisCmp.against': 'Verglichen mit',
  'adv.basisCmp.againstValue': 'Eigene Zahlen aus {year}',
  'adv.basisCmp.source': 'Datenquelle',
  'adv.basisCmp.sourceValue': 'In Plumme gebuchte Zahlen',
  'adv.basisCmp.industry': 'Branchendaten',
  'adv.basisCmp.industryValue': 'Nicht verfügbar',
  'adv.basisCmp.row.previousYear': 'vs. {year}',
  'adv.basisCmp.row.threshold': 'vs. festen Schwellenwert',
  'adv.hero.tag': 'SuperPlummas Einblick diesen Monat',
  'adv.hero.empty': 'AI Berater benötigt gebuchte Erträge, Kosten und offene Posten, bevor er konkrete Ratschläge geben kann.',
  'adv.hero.freeCapital': 'Freies Kapital',
  'adv.hero.notCalculated': 'nicht berechnet',
  'adv.hero.healthScore': 'Gesundheitsscore',
  'adv.hero.waiting': 'ausstehend',
  'adv.hero.ask': 'SuperPlumma fragen',
  'adv.hero.chatTitle': 'Mit SuperPlumma chatten',
  'adv.hero.chatHint': 'Chatte mit mir',
  'adv.hero.briefTag': 'Monatlicher Einblick von SuperPlumma · {year}',
  'adv.hero.healthLead': 'Finanzielle Gesundheit:',
  'adv.hero.greeting.morning': 'Guten Morgen.',
  'adv.hero.greeting.day': 'Hallo.',
  'adv.hero.greeting.evening': 'Guten Abend.',
  'adv.hero.greetingNamed.morning': 'Guten Morgen, {name}.',
  'adv.hero.greetingNamed.day': 'Hallo, {name}.',
  'adv.hero.greetingNamed.evening': 'Guten Abend, {name}.',
  'adv.hero.tasksToday': '{count} Dinge für heute',
  'adv.hero.seeAnalysis': 'Analyse ansehen',
  'adv.hero.effectNote.earlierIn': 'früher rein',
  'adv.hero.effectNote.overduePayables': 'überfällig an Lieferanten',
  'adv.hero.effectNote.vatToCover': 'muss gedeckt werden',
  'adv.hero.effectNote.vouchersAtRisk': 'Käufe ohne Beleg',
  'adv.overnight.title': 'SuperPlumma hat durchgesehen',
  'adv.overnight.transactions': '{count} Transaktionen analysiert',
  'adv.overnight.vouchers': '{count} Belege geprüft',
  'adv.overnight.risks': '{count} Risiken bewertet',
  'adv.overnight.recommendations': '{count} Empfehlungen gefunden',
  'adv.overnight.updated': 'Zuletzt aktualisiert {time}',
  'adv.analysis.title': 'Offene AI-Analyse der Buchhaltung',
  'adv.analysis.empty': 'Die Analyse ist gerade nicht verfügbar.',
  'adv.feed.title': 'SuperPlumma hat aufgepasst',
  'adv.feed.sub': 'Was mir zuletzt aufgefallen ist',
  'adv.feed.help': 'Veränderungen, die ich in der Buchhaltung entdeckt habe — keine Empfehlungen. Rot ist dringend, Gelb sollte nachverfolgt werden, Grün dient nur zur Information.',
  'adv.feed.seeDetails': 'Details ansehen',
  'adv.feed.marginDown.title': 'Die Umsatzrendite ist um {points} Prozentpunkte gesunken',
  'adv.feed.marginDown.body': 'Gemessen am Vorjahr. Einen genaueren Blick wert, bevor es zum Trend wird.',
  'adv.feed.marginUp.title': 'Die Umsatzrendite ist um {points} Prozentpunkte gestiegen',
  'adv.feed.marginUp.body': 'Gemessen am Vorjahr. Keine Maßnahmen nötig — nur gut zu wissen.',
  'adv.feed.costLineJump.title': '{name} ist um {pct} % gestiegen',
  'adv.feed.costLineJump.body': 'Dieser Kostenposten wächst im Vergleich zum Vorjahr schneller als der Rest.',
  'adv.feed.overdueSales.title': '{amount} an Kundenforderungen sind überfällig',
  'adv.feed.overdueSales.body': 'Das Geld ist bereits verdient — es muss nur noch eingehen.',
  'adv.feed.overduePurchases.title': '{amount} an Lieferantenforderungen sind überfällig',
  'adv.feed.overduePurchases.body': 'Überfällige Lieferantenforderungen können Verzugszinsen und Mahngebühren auslösen.',
  'adv.feed.concentration.title': 'Ein Kunde steht für {pct} % des Umsatzes',
  'adv.feed.concentration.body': 'Eine hohe Kundenabhängigkeit macht den Umsatz anfällig, wenn dieser Kunde wegfällt.',
  'adv.feed.costsDown.title': 'Die Kosten sind gegenüber dem Vorjahr um {pct} % gesunken',
  'adv.feed.costsDown.body': 'Keine Maßnahmen nötig — nur gut zu wissen.',
  'adv.feed.incomeUp.title': 'Der Umsatz ist gegenüber dem Vorjahr um {pct} % gestiegen',
  'adv.feed.incomeUp.body': 'Das Wachstum ist aus gebuchten Erträgen im selben Zeitraum berechnet.',
  'adv.feed.vouchersComplete.title': 'Alle Käufe haben Belege',
  'adv.feed.vouchersComplete.body': 'Hier braucht gerade nichts deine Aufmerksamkeit.',
  'adv.employees.title': 'Mitarbeitende & Lohn',
  'adv.employees.help': 'Dieses Modul wird nur angezeigt, weil das Unternehmen Mitarbeitende oder Lohnläufe hat. Die Zahlen stammen aus gebuchten Lohnkosten und deinen Lohnläufen.',
  'adv.employees.count': 'Mitarbeitende',
  'adv.employees.share': 'Lohnkosten / Umsatz',
  'adv.employees.cost': 'Gebuchte Lohnkosten',
  'adv.employees.runs': 'Lohnläufe in diesem Jahr',
  'adv.employees.note': 'Der Lohnanteil ist aus gebuchten Konten der 5000er-Reihe im Verhältnis zum Umsatz des Jahres berechnet.',
  'adv.employees.go': 'Lohn ansehen',
  'adv.taskcenter.title': 'Meine Aufgaben von SuperPlumma',
  'adv.taskcenter.all': 'Alle',
  'adv.taskcenter.empty': 'Keine Aufgaben in dieser Kategorie.',
  'adv.status.bucket.now': 'Jetzt handeln',
  'adv.profile.title': 'Beraterprofil',
  'adv.profile.help': 'Alles, was SuperPlumma darüber weiß, wie du beraten werden möchtest — Puffer, Ziel, Risikoniveau und Häufigkeit — an einem Ort. Du kannst hier alles ändern.',
  'adv.profile.intro': 'Das nutze ich, um die Ratschläge treffsicherer zu machen. Änderst du hier etwas, ändert das, wie ich priorisiere — nicht, wie die Buchhaltung geführt wird.',
  'adv.profile.buffer': 'Gewünschter Puffer',
  'adv.profile.mainGoal': 'Wichtigstes Ziel',
  'adv.profile.mainGoal.revenue': 'Umsatz steigern',
  'adv.profile.mainGoal.profitability': 'Rentabilität steigern',
  'adv.profile.mainGoal.buffer': 'Liquiditätspuffer aufbauen',
  'adv.profile.mainGoal.hiring': 'Einstellen',
  'adv.profile.mainGoal.investment': 'Investieren',
  'adv.profile.mainGoal.workload': 'Arbeitsbelastung reduzieren',
  'adv.profile.mainGoal.dividend': 'Das Unternehmen dividendenbereit machen',
  'adv.profile.risk': 'Bevorzugtes Risikoniveau',
  'adv.profile.risk.cautious': 'Sicher und vorsichtig',
  'adv.profile.risk.balanced': 'Ausgewogen',
  'adv.profile.risk.offensive': 'Risikobereit',
  'adv.profile.cadence': 'Wie oft du Ratschläge möchtest',
  'adv.profile.cadence.daily': 'Täglich',
  'adv.profile.cadence.weekly': 'Wöchentlich',
  'adv.profile.cadence.monthly': 'Monatlich',
  'adv.profile.accountantInvolved': 'Buchhalter bei Vorschlägen einbeziehen, die eine Beurteilung erfordern',
  'adv.profile.investments': 'Geplante Ereignisse',
  'adv.profile.noInvestments': 'Keine erfasst',
  'adv.profile.season': 'Saisonmuster',
  'adv.profile.seasonText': 'Starke Monate: {strong}. Schwache Monate: {weak}.',
  'adv.profile.noSeason': 'Noch zu wenig gebucht, um ein Muster zu erkennen.',
  'adv.profile.learned': 'Was ich aus deinen Entscheidungen gelernt habe',
  'adv.profile.nothingLearned': 'Noch nichts gelernt.',
  'adv.profile.saveFailed': 'Das Beraterprofil konnte nicht gespeichert werden',
  'adv.buffer.recommended': 'Empfohlener Puffer',
  'adv.buffer.chosen': 'Gewählter Puffer',
  'adv.buffer.edit': 'Liquiditätspuffer anpassen',
  'adv.buffer.editAria': 'Liquiditätspuffer von {amount} anpassen',
  'adv.buffer.title': 'Liquiditätspuffer',
  'adv.buffer.auto': 'Automatische Empfehlung',
  'adv.buffer.autoHelp': 'SuperPlumma verwendet den höchsten berechneten Bedarf. Aktuell liegt die Empfehlung bei {amount}.',
  'adv.buffer.custom': 'Eigener Betrag',
  'adv.buffer.customHelp': 'Diesen Betrag als feste Grenze für Ratschläge, Risiken und Cashflow verwenden.',
  'adv.buffer.amount': 'Gewünschter Puffer in Kronen',
  'adv.buffer.basisTitle': 'Grundlage der automatischen Empfehlung',
  'adv.buffer.basisMinimum': 'Mindestniveau',
  'adv.buffer.basisMonthlyCosts': 'Kosten eines Monats',
  'adv.buffer.basisTax': 'Berechnete Steuerreserve',
  'adv.buffer.basisVat': 'Anstehende MwSt.',
  'adv.buffer.basisHelp': 'Der automatische Puffer verwendet den höchsten dieser Beträge. Er ist eine Steuerungsgrenze, kein Geld auf einem separaten Konto.',
  'adv.buffer.saving': 'Wird gespeichert …',
  'adv.buffer.saved': 'Liquiditätspuffer gespeichert',
  'adv.buffer.invalid': 'Gib einen Betrag größer als 0 kr ein.',
  'adv.buffer.unavailable': 'Die Puffereinstellung ist gerade nicht verfügbar.',
  'adv.buffer.saveFailed': 'Der Liquiditätspuffer konnte nicht gespeichert werden.',
  'adv.generated.kicker': 'Offene AI-Analyse der Buchhaltung',
  'adv.generated.daily': 'Tagesrat',
  'adv.generated.monthly': 'Dieser Monat',
  'adv.generated.previousMonthly': 'Vormonat',
  'adv.generated.loading': 'SuperPlumma liest die aktualisierte Beratungsgrundlage …',
  'adv.generated.updated': 'Aktualisiert {date}',
  'adv.generated.topOpportunity': 'Dein größtes Potenzial',
  'adv.generated.changes': 'Was passiert gerade?',
  'adv.generated.actions': 'Das würde ich jetzt tun',
  'adv.generated.opportunities': 'Möglichkeiten',
  'adv.generated.taxChecks': 'Steuer und MwSt. – Kontrollpunkte',
  'adv.generated.more': 'Weitere Möglichkeiten und Kontrollpunkte ansehen',
  'adv.generated.nextStep': 'Nächster Schritt',
  'adv.generated.readOnly': 'Die Analyse ist nur beratend und führt keine Aktionen aus.',
  'adv.generated.importCoverage': 'Basierend auf importierten Summen und Offene-Posten-Salden. Die Prüfung einzelner Buchungen und der Belegvollständigkeit ist eingeschränkt.',
  'adv.generated.refresh': 'Rat aktualisieren',
  'adv.generated.failed': 'Der AI-Rat konnte gerade nicht aktualisiert werden.',
  'adv.generated.unavailable': 'Noch kein AI-Rat bereit',
  'adv.generated.empty': 'Es gibt noch keinen fertigen Rat zum Anzeigen. Versuch, die Ratschläge zu aktualisieren.',
  'adv.generated.limitReached': 'Das Monatslimit für neue AI-Ratschläge ist erreicht. Vorhandene Ratschläge bleiben verfügbar, und das Limit wird nächsten Monat zurückgesetzt.',
  'adv.generated.todayCurrent': 'Der Tagesrat ist bereit',
  'adv.generated.monthCurrent': 'Der Monatsrat wurde heute aktualisiert',
  'adv.generated.previousMonthCurrent': 'Der Rückblick wurde heute aktualisiert',
  'adv.generated.noDataChanges': 'Keine neuen Daten',
  'adv.generated.monthCooldown': 'Wird wöchentlich aktualisiert',
  'adv.generated.todayAlreadyCurrent': 'Der heutige Rat ist bereits verfügbar. Einen neuen Tagesrat bekommst du frühestens morgen.',
  'adv.generated.monthAlreadyCurrent': 'Der Monatsrat wurde heute aktualisiert. Er kann morgen erneut aktualisiert werden, wenn sich die Buchhaltungsgrundlage ändert.',
  'adv.generated.previousMonthAlreadyCurrent': 'Der Rückblick wurde heute aktualisiert. Er kann morgen erneut aktualisiert werden, wenn im Zeitraum neue Daten gebucht werden.',
  'adv.generated.noDataChangesInfo': 'Seit dem letzten Rat gibt es keine neuen Buchhaltungsdaten. Es wurde kein AI-Aufruf verwendet.',
  'adv.generated.monthCooldownInfo': 'Der Monatsrat kann einmal pro Woche aktualisiert werden, wenn sich die Buchhaltungsgrundlage geändert hat.',
  'adv.generated.previousKept': 'Der vorherige Rat bleibt bestehen.',
  'adv.generated.type.booked': 'Gebuchte Tatsache',
  'adv.generated.type.calculated': 'Berechnet',
  'adv.generated.type.scenario': 'Szenario',
  'adv.generated.type.opportunity': 'Chance',
  'adv.generated.type.control': 'Kontrollpunkt',
  'adv.generated.confidence.high': 'Gute Grundlage',
  'adv.generated.confidence.medium': 'Mittlere Grundlage',
  'adv.generated.confidence.low': 'Dünne Grundlage',
  'adv.health.title': 'Finanzieller Gesundheitsscore',
  'adv.health.sub': 'Gesamtbewertung der finanziellen Lage des Unternehmens',
  'adv.health.help': 'Ein Gesamtscore wird nur angezeigt, wenn alle vier Kennzahlen berechnet werden können. Unbekannte Werte geben keine Punkte. Sieh in der Datengrundlage nach, was fehlt.',
  'adv.health.badge.good': 'Gesund',
  'adv.health.badge.stable': 'Stabil',
  'adv.health.badge.weak': 'Schwach',
  'adv.health.badge.none': 'Nicht genug Daten',
  'adv.health.word.good': 'Gute finanzielle Gesundheit',
  'adv.health.word.stable': 'Stabile Finanzen',
  'adv.health.word.weak': 'Braucht Aufmerksamkeit',
  'adv.health.word.none': 'Vorläufige Bewertung',
  'adv.health.emptyTitle': 'Nicht genug Daten für einen Gesundheitsscore',
  'adv.health.emptyText': 'Buche Verkäufe, Einkäufe und offene Posten, um die Analyse zu aktivieren.',
  'adv.health.summaryFallback': 'SuperPlumma bewertet Liquidität, Wachstum, Rentabilität und Stabilität anhand deiner Buchhaltung.',
  'vat.wordMva': 'MwSt.',
  'vat.wordMoms': 'MwSt.',
  'vat.exemptMva': 'Außerhalb des MwSt.-Gesetzes',
  'vat.exemptMoms': 'Ohne MwSt.',
  'vat.rateLabel': '{{rate}} % {{word}}',
  'vat.zeroRated': '0 % {{suffix}}',
  'vat.zeroRatedSuffixMva': 'befreit',
  'vat.zeroRatedSuffixMoms': 'MwSt.-frei',
  'vat.salesReverseCharge51': '51 - Umkehr der Steuerschuldnerschaft beim Verkauf',
  'vat.export52': '52 - Export/Ausfuhr',
  'adv.health.category.likviditet': 'Liquidität',
  'adv.health.category.vekst': 'Wachstum',
  'adv.health.category.lonnsomhet': 'Rentabilität',
  'adv.health.category.stabilitet': 'Stabilität',
  'adv.health.note.noOpenPayables': 'Keine offenen Lieferantenforderungen erfasst',
  'adv.health.note.noDebt': 'Keine Verbindlichkeiten',
  'adv.health.note.unknown': 'Unbekannt',
  'adv.health.note.receivablesVsPayables': 'Kundenforderungen im Verhältnis zu offenen Lieferantenforderungen',
  'adv.health.note.zeroPrevYearRevenue': 'Der Vorjahresumsatz ist 0; prozentuales Wachstum kann nicht berechnet werden',
  'adv.health.note.needsPrevYear': 'Vorjahreszahlen für den Vergleich erforderlich',
  'adv.health.note.revenueChangeVsPrevYear': 'Umsatzänderung gegenüber dem Vorjahreszeitraum',
  'adv.health.note.marginFromReport': 'Ergebnismarge aus der Gewinn- und Verlustrechnung',
  'adv.health.note.noBookedRevenue': 'Kein gebuchter Umsatz im gewählten Jahr',
  'adv.health.note.largestCustomerShare': 'Umsatzanteil des größten Kunden',
  'adv.health.note.needsInvoicesPerCustomer': 'Rechnungsumsatz pro Kunde erforderlich',
  'adv.help.healthCard': 'Der Gesundheitsscore ist eine einfache Gesamtzahl von 0 bis 100. Er betrachtet mehrere Dinge gleichzeitig, etwa Geld auf dem Konto, Einnahmen, Kosten und Risiko. Er ist ein Anhaltspunkt, kein Urteil.',
  'adv.help.liquidity': 'Dieser Betrag ist offene Kundenforderungen minus offene Lieferantenforderungen. Er zeigt nicht, wie viel Geld auf dem Bankkonto ist.',
  'adv.help.expectedBalance': 'Berechneter Plansaldo am Ende des Zeitraums. Die Zahlen basieren nicht auf einem abgestimmten Banksaldo oder sicheren Zahlungsterminen.',
  'adv.help.expectedIn': 'Gebuchte Einnahmen im angezeigten Zeitfenster, keine bestätigten Zahlungseingänge.',
  'adv.help.expectedOut': 'Gebuchte Kosten im angezeigten Zeitfenster, keine bestätigten Auszahlungen.',
  'adv.help.cashBalance': 'Der Saldo ist das Geld, das in dieser Berechnung gerade verfügbar ist.',
  'adv.help.bookedIn': 'Gebucht ein sind Einnahmen oder Zahlungseingänge, die für den Zeitraum bereits in der Buchhaltung erfasst sind.',
  'adv.help.bookedOut': 'Gebucht aus sind Kosten oder Auszahlungen, die für den Zeitraum bereits in der Buchhaltung erfasst sind.',
  'adv.help.endBalance': 'Der Endsaldo ist der heutige Saldo plus Geldeingänge minus Geldausgänge. Er zeigt, wo der Kassenbestand in dieser Berechnung endet.',
  'adv.help.buffer': 'Der Liquiditätspuffer ist eine gewünschte Sicherheitsgrenze. Es ist kein eigenes Konto, sondern ein Betrag, den Plumme verwendet, um zu warnen, wenn der Kassenbestand zu niedrig wird.',
  'adv.help.bufferMinimum': 'Das Mindestniveau ist der niedrigste von Plumme empfohlene Puffer. Es verhindert, dass die Empfehlung zu niedrig ausfällt, wenn das Unternehmen wenig Historie hat.',
  'adv.help.monthlyCosts': 'Die Kosten eines Monats entsprechen ungefähr dem, was das Unternehmen normalerweise in einem Monat ausgibt. Das hilft dir, einen schwachen Monat zu überstehen.',
  'adv.help.taxReserve': 'Die Steuerrücklage ist Geld, das du für Steuern zurücklegen solltest, damit die Steuerrechnung keine Überraschung wird.',
  'adv.help.vatDue': 'Die anstehende MwSt. ist Mehrwertsteuer, die voraussichtlich zur nächsten MwSt.-Frist zu zahlen ist.',
});
